module.exports = __webpack_public_path__ + "static/media/babyShower.4370c8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/babyShower.png
// module id = 2311
// module chunks = 0